import React, { useContext } from "react";
import axios from "axios";
import "./messageCard.scss";
import PropTypes from "prop-types";
import goodIcon from "../../../../../../../../../images/aji_image/goodIcon.svg";
import badIcon from "../../../../../../../../../images/aji_image/badIcon.svg";
import { StoreContext } from "../../../../../../../../store/StoreProvider";
import ajiConfig from "../../ajiConfig";
import ApiUrls from "../../../../../../../../api/project/ApiUrls";

const MessageCard = ({
  messageObj,
  ajiChatbotIcon,
  userIcon,
  chatMessage,
  setChatMessage,
}) => {
  const [state, _] = useContext(StoreContext);
  const { user } = state;
  const { uid } = user;

  const postMessageToDb = async (postData) => {
    try {
      await axios.post(ApiUrls.postRateToDbUrl, postData);
    } catch (e) {
      console.log("錯誤：", e);
    }
  };

  const handleRateClick = (type) => {
    const curMessage = chatMessage.find((item) => messageObj.id === item.id);
    if (curMessage.rate === "") {
      const copyChatMessage = JSON.parse(JSON.stringify(chatMessage));
      const updatedChatMessage = copyChatMessage.map((item, index) => {
        if (messageObj.id === item.id) {
          const postData = {
            entry: {
              graph: "QARecord",
              classType: "QA",
              srcId: messageObj.id,
              value: {
                label_QA: "",
                timestamp: `${messageObj.timestamp}`,
                question: copyChatMessage[index - 1].message,
                answer: messageObj.message,
                rate: type,
                uid,
              },
            },
          };
          postMessageToDb(postData);
          return { ...item, rate: type };
        }
        return item;
      });
      setChatMessage(updatedChatMessage);
    }
  };

  return (
    <div
      className="messageGroup"
      style={{
        padding:
          messageObj.type === ajiConfig.msgType.ai
            ? "0px 24px 0px 0px"
            : "0px 0px 0px 24px",
      }}
    >
      <div
        className="message"
        style={{
          backgroundColor:
            messageObj.type === ajiConfig.msgType.ai && "#F1F9FE",
          border: messageObj.type === ajiConfig.msgType.ai && "none",
        }}
      >
        {messageObj.type === ajiConfig.msgType.ai && (
          <div>
            <img src={ajiChatbotIcon} alt="" />
          </div>
        )}
        <div className="messageContent">
          <p>{messageObj.message}</p>
          {messageObj.dataSource && (
            <div className="messageDataFromGroup">
              <div>
                <p>{messageObj.dataSource.title}</p>
                <ul>
                  {messageObj.dataSource.source.map((item, sourceIndex) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <li key={sourceIndex}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
        {messageObj.type !== ajiConfig.msgType.ai && (
          <div>
            <img src={userIcon} alt="" />
          </div>
        )}
      </div>
      <div
        className="messageOtherFeatures"
        style={{
          justifyContent:
            messageObj.type === ajiConfig.msgType.ai ? "end" : "start",
        }}
      >
        {messageObj.type === ajiConfig.msgType.ai && (
          <div className="rate">
            <button
              type="button"
              onClick={() => handleRateClick(ajiConfig.rate.bad)}
              style={{
                backgroundColor:
                  messageObj.rate === ajiConfig.rate.bad && "#3BBFF01A",
              }}
              aria-label="badRate"
            >
              <img src={badIcon} alt="badRateIcon" />
            </button>
            <button
              type="button"
              onClick={() => handleRateClick(ajiConfig.rate.good)}
              style={{
                backgroundColor:
                  messageObj.rate === ajiConfig.rate.good && "#3BBFF01A",
              }}
              aria-label="goodRate"
            >
              <img src={goodIcon} alt="goodRateIcon" />
            </button>
          </div>
        )}
        <span>{messageObj.dataTime}</span>
      </div>
    </div>
  );
};

MessageCard.propTypes = {
  messageObj: PropTypes.object.isRequired,
  ajiChatbotIcon: PropTypes.string.isRequired,
  userIcon: PropTypes.string.isRequired,
  chatMessage: PropTypes.array.isRequired,
  setChatMessage: PropTypes.func.isRequired,
};

export default MessageCard;
